import { render } from "./ArrowLeft.vue?vue&type=template&id=36bd5e5e"
import script from "./ArrowLeft.vue?vue&type=script&lang=js"
export * from "./ArrowLeft.vue?vue&type=script&lang=js"
script.render = render

export default script